import './router/componentHooks' // <-- Needs to be first line
import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faArrowRight, faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import * as VueGoogleMaps from "vue2-google-maps";
import GmapCluster from 'vue2-google-maps/dist/components/cluster'
import Vuelidate from 'vuelidate'
import VueCookies from 'vue-cookies'
import 'sweetalert2/dist/sweetalert2.min.css';
import PrettyCheck from 'pretty-checkbox-vue/check';
import PrettyRadio from 'pretty-checkbox-vue/radio';
import VueGtag from "vue-gtag";
import VueGtm from "vue-gtm";

library.add(faArrowRight)
library.add(faArrowLeft)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('p-check', PrettyCheck);
Vue.component('p-radio', PrettyRadio);
Vue.component('gmap-cluster', GmapCluster)

Vue.use(VueGoogleMaps, {
    load: {
        key: "AIzaSyCojtIt7-Ug0nM8Wwt-qNcy_1Q4GZkKQU4",
        libraries: "places" // necessary for places input
    }
});

const AnalyticsDev = 'G-GQT0F6RL5X'
const AnalyticsUat = 'G-1LQ0XVRGHF'
const AnalyticsProd = 'G-4ZPCSPGBJK'

let analyticsId = AnalyticsDev;

if (location.host.includes('c4c.unitedwaysem.org')) {
    analyticsId = AnalyticsProd
    /* eslint-disable no-debugger, no-console */
    console.log("isProd")
} else if (location.host.includes('uat')) {
    analyticsId = AnalyticsUat
    /* eslint-disable no-debugger, no-console */
    console.log("isUat")
} else {
    /* eslint-disable no-debugger, no-console */
    console.log("isDev")
}

Vue.use(VueGtag, {
  config: { id: analyticsId },
}, router);

Vue.use(VueGtm, {
  id: "GTM-PWTJ9MXP",
  defer: false,
  enabled: true,
  debug: false,
  vueRouter: router, 
  trackOnNextTick: false
});

// eslint-disable-next-line
Vue.use(Vuelidate as any)
Vue.use(VueCookies)

// cookie settings
const expiresTime = '7d'
const path = '/'
const domain = ''
const secure = true
const sameSite = 'None'
Vue.$cookies.config(expiresTime, path, domain, secure, sameSite);

Vue.config.productionTip = false


new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')